import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import getSharedByDetails from 'utils/asset/getSharedByDetails';
import { checkIsPlaylist } from 'types/content/utils';
import FriendlyDuration from 'components/FriendlyDuration';
import { Billboard, ExternalLink, InfoIcons } from 'components/ContentCards';
import ContentProgressCircle from 'components/ContentProgressCircle';
import InlineList from 'components/InlineList';
import { GoalPill, SharedByPill } from 'components/Pill';
import { useDismissShare, useCardContentDetails } from 'components/ContentCards/controllers';
import useOnWebAssetClick from './useOnWebAssetClick';
import { DIMENSIONS } from 'utils/image/getPictureUrl';
import getHubContentLink from './getHubContentLink';
var SmartBillboardShared = function SmartBillboardShared(_ref) {
  var item = _ref.item;
  var id = item.id,
    name = item.name,
    description = item.description,
    user_rated_like = item.user_rated_like,
    goal = item.goal,
    commentCount = item.commentCount,
    commentCountUser = item.commentCountUser,
    rating_count = item.rating_count,
    pictureUrl = item.pictureUrl,
    parentContentId = item.parentContentId;
  var isPlaylist = checkIsPlaylist(item);
  var badge = isPlaylist ? item.badge : undefined;
  var hasUserBadge = isPlaylist ? item.hasUserBadge : false;
  var isSaved = isPlaylist ? item.isSaved : false;
  var audience = isPlaylist ? item.audience || 'all' : 'all';
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useCardContentDetail = useCardContentDetails(item),
    contentCount = _useCardContentDetail.contentCount,
    duration = _useCardContentDetail.duration,
    progress = _useCardContentDetail.progress,
    type = _useCardContentDetail.type,
    icon = _useCardContentDetail.icon;
  var _useOnWebAssetClick = useOnWebAssetClick(),
    onWebAssetClick = _useOnWebAssetClick.onWebAssetClick;
  var _useDismissShare = useDismissShare(id),
    dismissShare = _useDismissShare.dismissShare;
  var qaId = useUniqueId(id.toString());
  var link = getHubContentLink({
    id: id,
    type: type.value,
    parentId: parentContentId
  });
  var sharedBy = getSharedByDetails(item);
  var contentCountReadout = contentCount.value ? contentCount.readable : undefined;
  return /*#__PURE__*/React.createElement(Billboard, {
    id: "collection_title_".concat(qaId),
    link: link,
    icon: icon,
    imageSource: pictureUrl ? "".concat(pictureUrl, "/").concat(DIMENSIONS.BILLBOARD) : undefined,
    badge: badge,
    hasUserBadge: hasUserBadge,
    title: name,
    subtitle: /*#__PURE__*/React.createElement(InlineList, {
      as: "span",
      itemAs: "span",
      splitBy: "dot",
      display: "inline"
    }, type.readable, contentCountReadout, duration > 0 && /*#__PURE__*/React.createElement(FriendlyDuration, {
      value: duration
    }), type.value !== 'topic' && progress && /*#__PURE__*/React.createElement(ContentProgressCircle, {
      contentName: name,
      progress: progress,
      infoReadout: "full",
      scale: 5 / 6
    }), item.type === 'web' && !!item.webUrl && item.openInIframe === false && /*#__PURE__*/React.createElement(ExternalLink, {
      webUrl: item.webUrl,
      assetName: item.name,
      onWasClicked: function onWasClicked() {
        return onWebAssetClick({
          type: item.type,
          markAsDoneMode: isPlaylist ? undefined : item.markAsDoneMode,
          userContentStatus: item.userContentStatus,
          contentId: item.id
        });
      }
    })),
    description: description,
    menuItems: [{
      value: t('actions_discard'),
      onSelect: dismissShare
    }],
    infoIcons: /*#__PURE__*/React.createElement(InfoIcons, {
      isSaved: isSaved,
      visibility: audience === 'admin' ? 'private' : undefined,
      likeCount: rating_count,
      commentCount: commentCount,
      commentCountUser: commentCountUser,
      hasUserLiked: user_rated_like
    }),
    priorityPill: goal ? /*#__PURE__*/React.createElement(GoalPill, {
      goal: goal
    }) : sharedBy ? /*#__PURE__*/React.createElement(SharedByPill, {
      pictureUrl: sharedBy.pictureUrl
    }, sharedBy.label) : undefined
  });
};
export default SmartBillboardShared;